module.exports = __webpack_public_path__ + "media/gerd.47a24725.wav";